export { SecurityPage as default } from '@/components/pages/Legal/SecurityPolicy'
